import { action, computed, makeObservable, observable } from 'mobx';

import { DeviceType } from 'types/DeviceType';
import { ViewModes } from 'types/ViewModes';
import { isMobileBrowser } from 'utils/UserAgent';

// With the reduction in surface area of this class, I'm making it an
// experiment in removing Store as a base class, and with it
// becomeObservable, with all its caveats and footguns.

class UI {
  collapsed = true;
  viewMode = ViewModes.NONE;
  fileDragging = false;
  areBreadcrumbsVisible = true;
  deviceType: DeviceType | null = null;

  constructor() {
    makeObservable(this, {
      collapsed: observable,
      viewMode: observable,
      fileDragging: observable,
      areBreadcrumbsVisible: observable,
      deviceType: observable,
      isMobile: computed,
      handleWindowResize: action.bound,
      updateDeviceType: action,
    });

    // Never torn down; this listener persists for the lifetime of the app
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  }

  get isMobile() {
    return this.deviceType === DeviceType.MOBILE;
  }

  handleWindowResize() {
    this.updateDeviceType();
  }

  updateDeviceType() {
    this.deviceType = isMobileBrowser()
      ? DeviceType.MOBILE
      : DeviceType.DESKTOP;
  }
}

export default UI;
